<template>
<div>
    <div class="w-full flex flex-wrap gap-10 items-center text-xl justify-end">
        <vs-radio color="warning" v-model="tipo_form" vs-value="textos" vs-name="tipo_textos">Textos</vs-radio>
    </div>
    <vs-list v-if="tmpPedidos">
        <vs-list-header title="Datos"></vs-list-header>
        <vs-list-item title="Institución" :subtitle="tmpPedidos.nombreInstitucion + ' ('+tmpPedidos.nombre_ciudad+')'"></vs-list-item>
        <vs-list-item title="Asesor" :subtitle="tmpPedidos.responsable"></vs-list-item>
        <vs-list-item title="Período" :subtitle="tmpPedidos.periodo"></vs-list-item>
    </vs-list>
    <div align="center" v-if="series.length <= 0"><b>El formato de precios no esta configurado para ningun texto en este período.</b></div>
    <!-- {{ tmpPedidos }} -->
    <!-- {{ series }} -->
    <vs-collapse>
        <vs-collapse-item v-for="(item, index) in series" :key="item.id_serie">
            <div slot="header" class="text-center">
                <br>
                <table>
                    <tr>
                        <td width="1000" v-if="item.totalPvnCantidad > 0">
                            <table align="center">
                                <tr>
                                    <td>
                                        <b style="font-size: 12px;">Total textos</b>
                                    </td>
                                    <td class="input_totales" width="150" align="center">
                                        <!-- Mostrar la suma total para esta serie -->
                                        {{ item.totalPvnCantidad }}
                                    </td>
                                    <td style="font-size: 12px;"><b>Subtotal usd</b></td>
                                    <td class="input_totales" width="150" align="center">
                                        ${{ item.totalPvpUsd.toFixed(2) }}
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td width="1000"><b>{{item.nombre_serie.toUpperCase()}}</b></td>
                    </tr>
                </table>
            </div>
            <!-- Buscador solo para id_serie == 19 -->
            <div v-if="item.id_serie == 19" class="px-4 py-2" align="center" style="max-width: 600px; margin: 0 auto;">
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px; color: #2c7be5; font-size: 14px; font-weight: 500; font-style: normal; user-select: none; ">
                  <i class="fas fa-info-circle" aria-hidden="true" style="font-size: 16px;"></i>
                  <span>
                      Selecciona uno o varios códigos que forman un combo para buscar y filtrar.
                  </span>
              </div>
              <v-select style="width: 100%;" placeholder="--Buscar y seleccionar--" multiple :closeOnSelect="false" v-model="codigos_combo_buscar" label="nombreCompleto" class="mb-4" :options="productos_Libros_Series" :reduce="(productos_Libros_Series) => productos_Libros_Series.codigo_liquidacion" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="w-full" style="overflow-x:auto;">
                <table class="table_pedidos">
                    <thead class="text-center">
                        <th style="width: 100px;"><b>Áreas</b></th>
                        <th :colspan="item.areas[0].libros.length + 1"><b>Niveles</b></th>
                    </thead>
                    <!-- FILTRAR ÁREAS según id_serie -->
                    <tr class="text-center" align="center" v-for="(tr, indextr) in (item.id_serie == 19 ? filtrarAreasPorCodigos(item.areas) : item.areas)" :key="tr.idarea">
                        <td style="background-color: #046AE7; color: white;"><b>{{ tr.nombrearea }}</b></td>
                        <td align="left">
                            <div v-for="(libro, libroIndex) in (item.id_serie == 19 ? filtrarLibrosPorCodigos(tr.libros) : tr.libros)" :key="libroIndex" style="display: inline-flex;">
                                <table style="width: 150px; border: 1px solid #000; margin: 0.5px">
                                    <tr>
                                        <td align="center" style="border: transparent">
                                            <div v-if="tr.idarea != 69">
                                                <p class="font-bold">{{ libro.pro_codigo }}</p>
                                                <b>{{ libro.year }}</b>
                                                <div v-if="item.id_serie == 19 && libro.pro_codigos_desglose && libro.pro_codigos_desglose.length > 0">
                                                    <div style="float: right;">
                                                        <vx-tooltip :text="libro.descripcionlibro" position="top" color="primary">
                                                            <i class="fas fa-info-circle" style="font-size: 13px; color: #2196f3; cursor: pointer;"></i>
                                                        </vx-tooltip>
                                                    </div>
                                                    <div style="padding: 0px; text-align: center;">
                                                        <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 4px; padding: 2px 4px;">
                                                            <vx-tooltip v-for="(combo, idx) in libro.pro_codigos_desglose" :key="idx" :text="combo.nombrelibro" position="top" color="primary">
                                                                <span style="font-size: 11px; padding: 2px 6px; border-radius: 10px; border: 1px solid #ccc; color: #333; background-color: transparent; white-space: nowrap; cursor: default; line-height: 1.2; cursor: pointer; ">
                                                                    {{ combo.codigo_liquidacion }}
                                                                </span>
                                                            </vx-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="min-height: 50px" v-else-if="tr.idarea == 69">{{ libro.nombrelibro }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" style="border: transparent">
                                            <div><b>PVP:</b> ${{ libro.pfn_pvp }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" style="border: transparent">
                                            <div style="width: 90px;">
                                                <vs-tooltip text="Cantidad" position="top" :color="tr.pfn_estado ? 'warning' : 'primary'">
                                                    <template>‎</template>
                                                    <vs-input @blur="((groupFacturador && sendPedido.verificaciones == 0 && sendPedido.ca_codigo_agrupado == null) ||  (userAsesor && sendPedido.contrato_generado == null)|| (userAsesor&& sendPedido.contrato_generado != null && sendPedido.permitir_editar_despues_contrato == 1 && sendPedido.ca_codigo_agrupado == null) )?blur_pvn_cantidad(libro):null" style="display: inline-flex;" class="w-full" v-model="libro.pvn_cantidad" @keypress="validarkey_pvn_cantidad($event, libro)" @paste="validarnopegar($event)" :readonly="!((groupFacturador && sendPedido.verificaciones == 0 && sendPedido.ca_codigo_agrupado == null) || (userAsesor && sendPedido.contrato_generado == null)|| (userAsesor&& sendPedido.contrato_generado != null && sendPedido.permitir_editar_despues_contrato == 1 && sendPedido.ca_codigo_agrupado == null) ) " maxlength="4" :class="{ 'cantidad-positiva': libro.pvn_cantidad > 0 }" />
                                                </vs-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </vs-collapse-item>
    </vs-collapse>
    <div class="w-full text-right">
        <b>
            CANTIDAD DE UNIDADES DE LIBROS TOTAL : <div style="width: 120px; display: inline-block;">{{calculos.cantidadtotal_libros}} </div><br>
            VENTA BRUTA : <div style="width: 120px; display: inline-block;">{{calculos.pvptotal_libros.toFixed(2)}} </div><br>
            <!-- {{porcentaje_descuento}}% COMISION: <div style="width: 120px; display: inline-block;">{{((total_usd*porcentaje_descuento)/100).toFixed(2) }} </div><br> -->
            <!-- TOTAL : <div style="width: 120px; display: inline-block;">{{(total_usd - ((total_usd*porcentaje_descuento)/100)).toFixed(2)}} </div> -->
            VENTA BRUTA SERIES BÁSICAS : <div style="width: 120px; display: inline-block;">{{ calculos.suma_seriesBasicas.toFixed(2) }} </div><br>
            MULTIPLICACION PORCENTAJE CONFG {{ porcentaje_descuento_series_basicas }}% : <div style="width: 120px; display: inline-block;">{{ calculos.multiplicacionPConfigurado.toFixed(2) }} </div><br>
            CALCULO AUTORIZADO : <div style="width: 120px; display: inline-block;">{{ calculos.RestaAutorizada.toFixed(2) }} </div><br>
            {{porcentaje_descuento}}% COMISION CALCULO AUTORIZADO: <div style="width: 120px; display: inline-block;">{{ calculos.resultadoComisionAsesor.toFixed(2) }} </div><br>
            <!-- ANTICIPO <div style="width: 120px; display: inline-block;">{{ Math.abs(anticipoAprobado).toFixed(2)  }} </div><br> -->
            ANTICIPO SUGERIDO<div style="width: 120px; display: inline-block;">{{ Math.abs(calculos.anticipo_calculado).toFixed(2)  }} </div><br>
            PENDIENTE POR LIQUIDAR <div style="width: 120px; display: inline-block;">{{ calculos.pendienteLiquidar.toFixed(2) }} </div><br>
        </b>
    </div>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select';
import axios from 'axios'
export default {
    components: {
        flatPickr,
        'v-select': vSelect,
    },
    data: () => ({
        usuario: [],
        series: [],
        series_plan_lector: [],
        calculos: {
            cantidadtotal_libros: 0,
            pvptotal_libros: 0,
            suma_seriesBasicas: 0,
            multiplicacionPConfigurado: 0,
            RestaAutorizada: 0,
            resultadoComisionAsesor: 0,
            anticipo_calculado: 0,
            pendienteLiquidar: 0,
            totalGuias: 0,
        },
        tipo_form: 'textos',
        pvn_tipo: 0,
        id_periodo: '',
        id_pedido: '',
        total_usd: 0,
        total_unidades: 0,
        total_unidades_guias: 0,
        porcentaje_descuento: 0,
        porcentaje_descuento_series_basicas: 0,
        isrunLoading_blur_pvn_cantidad: false,
        isrunLoading_metodoInicial: false,
        //variables para observacion y anticipo
        disableAsesor: false,
        pedido: {
            id_pedido: 0,
            periodo: '',
            tipo_venta: '',
            fecha_envio: '',
            fecha_entrega: '',
            institucion: '',
            asesor: '',
            descuento: '',
            anticipo: '',
            ifanticipo: 0,
            observacion: '',
            ruc: '',
            direccionInstitucion: '',
            nivel: '',
            tipo_descripcion: '',
            telefonoInstitucion: '',
            id_periodo: ''
        },
        //fin variables para  observacion y anticipo
        suma_bruta_series_b: 0,
        arregloSeriesBasicas: [],
        pendienteLiquidar: 0,
        anticipo_aprobado: 0,
        contrato_generado: '',
        multiplicacionPConfigurado: 0,
        RestaAutorizada: 0,
        resultadoComisionAsesor: 0,
        //variables de series basicas
        //variables de series basicas
        sendPedido: '',
        codigos_combo_buscar: [],
        productos_Libros_Series: [],
    }),
    props: {
        tmpPedidos: {
            type: Object,
            default: {},
            required: true
        },
        selectifanticipo: {
            type: Boolean,
            default: false,
            required: true
        },
        anticipoAprobado: {
            type: Number,
            default: 0,
            required: true
        },
    },
    computed: {
        ...mapState(["auth", 'userRoot', 'susuario', 'ObjectPedido', 'groupFacturador', 'userAsesor']),
    },
    mounted() {
        let me = this
        this.id_periodo = me.tmpPedidos.id_periodo
        this.usuario = JSON.parse(localStorage.getItem('usuario'))
        this.id_pedido = me.tmpPedidos.id_pedido
        me.sendPedido = me.ObjectPedido
        this.metodoInicial();
        // this.getLibrosPlanLector()
        if (this.usuario.id_group == 11) {
            this.disableAsesor = false
        } else {
            this.disableAsesor = true
        }
    },
    methods: {
        async metodoInicial() {
            let me = this;
            try {
                me.$vs.loading();
                me.isrunLoading_metodoInicial = true;
                await me.TraerLibro_Series_ParaBusqueda();
                await me.getAreasBasicas();
                await me.getSeries();
                await me.get_val_pedido();
                await me.calcularTotalPvnCantidad();
                // await me.calcularCantidadTotalLibros();
                // await me.calcularPVPTotalLibros();
                await me.calculosGenerales();
                await me.guardarTotalPedido();
                me.isrunLoading_metodoInicial = false;
                me.$vs.loading.close();
            } catch (error) {
                console.error('Error en metodoInicial:', error);
                me.$vs.loading.close();
            }
        },
        async blur_pvn_cantidad(libro) {
            let me = this;
            if (libro.pvn_cantidad === libro.pvn_cantidad_original) {
                console.log("No hay cambios");
                return;
            }
            try {
                console.log("El valor ha cambiado");
                // Solo mostrar el loading si no está activo
                if (!me.isrunLoading_blur_pvn_cantidad) {
                    me.isrunLoading_blur_pvn_cantidad = true;
                    me.$vs.loading();
                }
                await me.setearencero_pvn_cantidad(libro);
                await me.guardarCantidad_PedidosValNew(libro);
                // await me.getSeries();
                await me.get_val_pedido();
                await me.calcularTotalPvnCantidad();
                // await me.calcularCantidadTotalLibros();
                // await me.calcularPVPTotalLibros();
                await me.calculosGenerales();
                await me.guardarTotalPedido();
                libro.pvn_cantidad_original = libro.pvn_cantidad; // Actualizar el valor original
            } catch (error) {
                console.error("Error en blur_pvn_cantidad:", error);
            } finally {
                // Cerrar loading solo si no hay otra ejecución en proceso
                me.isrunLoading_blur_pvn_cantidad = false;
                me.$vs.loading.close();
            }
        },
        async calcularTotalPvnCantidad() {
            return new Promise((resolve, reject) => {
                if (!Array.isArray(this.series)) {
                    console.error("`this.series` no es un array:", this.series);
                    return reject("`this.series` no es un array");
                }
                let cantidadtotalLibros = 0;
                let pvptotalLibros = 0;
                this.series.forEach(serie => {
                    let totalPvnCantidad = 0;
                    let totalPvpUsd = 0;
                    if (Array.isArray(serie.areas)) {
                        serie.areas.forEach(area => {
                            if (Array.isArray(area.libros)) {
                                area.libros.forEach(libro => {
                                    // Convertir a número antes de sumar
                                    totalPvnCantidad += +libro.pvn_cantidad || 0;
                                    const totalPvpUsdLibro = parseFloat(
                                        (libro.pfn_pvp * (+libro.pvn_cantidad || 0)).toFixed(2)
                                    );
                                    this.$set(libro, 'totalPvpUsdLibro', totalPvpUsdLibro);
                                    totalPvpUsd += totalPvpUsdLibro;
                                });
                            }
                        });
                    }
                    this.$set(serie, 'totalPvnCantidad', totalPvnCantidad);
                    this.$set(serie, 'totalPvpUsd', totalPvpUsd);
                    cantidadtotalLibros += totalPvnCantidad;
                    pvptotalLibros += totalPvpUsd;
                });
                this.calculos.cantidadtotal_libros = cantidadtotalLibros;
                this.calculos.pvptotal_libros = parseFloat(pvptotalLibros.toFixed(2));
                resolve();
            });
        },
        // async calcularCantidadTotalLibros() {
        //     return new Promise((resolve, reject) => {
        //         this.calculos.cantidadtotal_libros = this.series.reduce((total, serie) => {
        //             return total + serie.totalPvnCantidad;
        //         }, 0);
        //         resolve();
        //     });
        // },
        // async calcularPVPTotalLibros() {
        //     return new Promise((resolve, reject) => {
        //         this.calculos.pvptotal_libros = parseFloat(
        //             this.series.reduce((total, serie) => {
        //                 return total + serie.totalPvpUsd;
        //             }, 0).toFixed(2)
        //         );
        //         resolve();
        //     });
        // },
        async calculosGenerales() {
            // Extraer los nombres de serie basica
            let me = this;
            return new Promise((resolve, reject) => {
                // console.log(me.arregloSeriesBasicas, "arreglosbasioca");
                const nombresSeriesBasicas = me.arregloSeriesBasicas.map(item => item.nombre_serie);
                // console.log(nombresSeriesBasicas, "nombre extraidos");
                // Filtrar las series cuyo nombre coincide exactamente con los nombres en me.arregloSeriesBasicas
                const totalSumado = me.series
                    .filter(serie => nombresSeriesBasicas.includes(serie.nombre_serie))
                    .reduce((total, serie) => total + serie.totalPvpUsd, 0);

                me.calculos.suma_seriesBasicas = parseFloat(totalSumado.toFixed(2));
                me.calculos.multiplicacionPConfigurado = parseFloat(((me.calculos.suma_seriesBasicas * me.porcentaje_descuento_series_basicas) / 100).toFixed(2));
                me.calculos.RestaAutorizada = parseFloat((me.calculos.suma_seriesBasicas - me.calculos.multiplicacionPConfigurado).toFixed(2));
                me.calculos.resultadoComisionAsesor = parseFloat(((me.calculos.RestaAutorizada * me.porcentaje_descuento) / 100).toFixed(2));
                me.calculos.anticipo_calculado = parseFloat((me.calculos.resultadoComisionAsesor * 0.5).toFixed(2)); // 50% de comision
                // me.calculos.pendienteLiquidar = parseFloat(me.calculos.resultadoComisionAsesor - Math.abs(me.anticipoAprobado));
                me.calculos.pendienteLiquidar = parseFloat(me.calculos.resultadoComisionAsesor - Math.abs(me.calculos.anticipo_calculado));
                resolve();
            });
        },
        async setearencero_pvn_cantidad(libro) {
            return new Promise((resolve, reject) => {
                // Convertir a número entero y eliminar ceros a la izquierda
                libro.pvn_cantidad = libro.pvn_cantidad ? parseInt(libro.pvn_cantidad, 10) : 0;
                resolve();
            });
        },
        async getSeries() {
            let me = this;
            return new Promise((resolve, reject) => {
                if (me.isrunLoading_metodoInicial == false && me.isrunLoading_blur_pvn_cantidad == false) {
                    me.$vs.loading();
                }
                this.$http.get(this.$server_url + 'series_formato_periodo_new/' + me.id_periodo + '/' + me.id_pedido + '/' + me.pvn_tipo)
                    .then(res => {
                        me.series = Object.values(res.data);
                        // Establecer pvn_cantidad_original en cada libro
                        me.series.forEach(serie => {
                            serie.areas.forEach(area => {
                                area.libros.forEach(libro => {
                                    libro.pvn_cantidad_original = libro.pvn_cantidad; // Guardar valor inicial
                                });
                            });
                        });
                        // console.log(me.series, "valiiiiiiiid");
                        if (me.isrunLoading_metodoInicial == false && me.isrunLoading_blur_pvn_cantidad == false) {
                            me.$vs.loading.close();
                        }
                        resolve();
                    })
                    .catch(error => {
                        // ⚠️ Capturar el error y mostrar en notify
                        let mensaje = 'Error inesperado';
                        if (error.response && error.response.data && error.response.data.message) {
                            mensaje = error.response.data.message;
                        } else if (error.message) {
                            mensaje = error.message;
                        }
                        me.$vs.notify({
                            text: mensaje,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x',
                            time: 9000
                        });
                        if (me.isrunLoading_metodoInicial == false && me.isrunLoading_blur_pvn_cantidad == false) {
                            me.$vs.loading.close();
                        }
                        reject(error);
                    });
            });
        },
        validarkey_pvn_cantidad(event, libro) {
            let numentero = libro.pvn_cantidad;
            // Verificar si la tecla presionada es un número.
            if (!/\d/.test(event.key)) {
                event.preventDefault();
                return;
            }
            // Validar el formato del número
            // if (!/^\d{0,5}(\.\d{0,3})?$/.test(numentero)) {
            //     libro.pvn_cantidad = '';
            //     console.log("reset");
            // }
        },
        validarnopegar(event) {
            // Obtener el texto pegado
            let pastedText = (event.clipboardData || window.clipboardData).getData('text');

            // Verificar si el texto pegado contiene solo números
            if (!/^\d+$/.test(pastedText)) {
                event.preventDefault();
                return;
            }
        },
        restringirTab(event) {
            if (event.key === 'Tab') {
                event.preventDefault(); // Previene el cambio de foco con la tecla Tab
                console.log("Tecla Tab restringida");
            }
        },
        async guardarCantidad_PedidosValNew(libro) {
            let me = this;
            return new Promise((resolve, reject) => {
                // console.log(me.idmovimiento.fmp_id, "idmovimientfoinal");
                // console.log(me.CompletoIngreso, "idmovimientfoina2l");
                // return
                // Busca el proveedor con el prov_id específico

                let datos = {
                    "idlibro": libro.idlibro,
                    "totalPvpUsdLibro": libro.totalPvpUsdLibro,
                    "pvn_cantidad": libro.pvn_cantidad,
                    "pvn_tipo": me.pvn_tipo,
                    "id_pedido": me.id_pedido
                }
                // console.log(datos, "datosssssss")
                // return;
                if (me.isrunLoading_metodoInicial == false && me.isrunLoading_blur_pvn_cantidad == false) {
                    me.$vs.loading()
                }
                //axios.post(this.$apifacturacion_url + 'f_Vendedor', datos)
                this.$http.post(this.$server_url + 'PostRegistrar_modificar_pedidosNew', datos)
                    .then(res => {
                        // this.getMaterialcubiertaParametro();
                        if (res.data.status == "0") {
                            me.$vs.notify({
                                text: res.data.message, // Mensaje para el estado "0"
                                color: 'warning', // Color de advertencia para errores o situaciones especiales
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        } else if (res.data.status == "1") {
                            me.$vs.notify({
                                text: res.data.message, // Mensaje para el estado "1"
                                color: 'success', // Color de éxito para confirmaciones
                                iconPack: 'feather',
                                icon: 'icon-check'
                            });
                        }
                        if (me.isrunLoading_metodoInicial == false && me.isrunLoading_blur_pvn_cantidad == false) {
                            me.$vs.loading.close()
                        }
                        resolve();
                    })
                    .catch(function () {
                        me.$vs.loading.close()
                        me.$vs.notify({
                            text: 'Registro no se pudo actualizar.',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        })
                        reject(error);
                    })
            });
        },
        async getAreasBasicas() {
            let me = this;
            return new Promise((resolve, reject) => {
                this.$http.get(this.$server_url + 'getSeriesBasicas/' + me.id_periodo)
                    .then(res => {
                        me.arregloSeriesBasicas = res.data.filter(p => p.serie_basica == 1)
                        // console.log(me.arregloSeriesBasicas, "aregloseries");
                        resolve();
                    })
            });
        },
        async get_val_pedido() {
            let me = this
            return new Promise((resolve, reject) => {
                if (!me.id_pedido) {
                    return
                }
                if (me.isrunLoading_metodoInicial == false && me.isrunLoading_blur_pvn_cantidad == false) {
                    me.$vs.loading()
                }
                this.$http.get(this.$server_url + 'get_val_pedido_new/' + me.id_pedido)
                    .then(res => {
                        if (res.data.length <= 0) {
                            me.porcentaje_descuento = 0;
                            me.porcentaje_descuento_series_basicas = 0;
                            me.contrato_generado = 0;
                            if (me.isrunLoading_metodoInicial == false && me.isrunLoading_blur_pvn_cantidad == false) {
                                me.$vs.loading.close()
                            }
                        } else if (res.data.length > 0) {
                            me.porcentaje_descuento = res.data[0].descuento
                            me.porcentaje_descuento_series_basicas = res.data[0].porcentaje_descuento
                            me.contrato_generado = res.data[0].contrato_generado
                            if (me.isrunLoading_metodoInicial == false && me.isrunLoading_blur_pvn_cantidad == false) {
                                me.$vs.loading.close()
                            }
                        }
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                        me.$vs.loading.close()
                    })
            })
        },
        EsMultiploDeCinco(numero) {
            return numero % 5 == 0;
        },
        async guardarTotalPedido() {
            let me = this
            // console.log(me.id_pedido, me.calculos.pvptotal_libros, me.calculos.cantidadtotal_libros, me.calculos.suma_seriesBasicas,
            //     me.calculos.anticipo_calculado, "hoaaaaaaaaa");
            // return;
            return new Promise((resolve, reject) => {
                me.$http.get(me.$server_url + 'guardar_total_pedido_new/' + me.id_pedido + '/' + me.calculos.pvptotal_libros + '/' + me.calculos.cantidadtotal_libros + '/' + me.calculos.totalGuias + '/' + me.calculos.suma_seriesBasicas + '/' + me.calculos.anticipo_calculado)
                    .then(res => {
                        resolve();
                        me.$emit('rechargePedido', true);
                        // console.log('total actualizado: ' + total_usd_format)
                    })
                    .catch(err => {
                        reject(err);
                        me.$vs.loading.close()
                    })
            })
        },
        async TraerLibro_Series_ParaBusqueda() {
            let me = this;
            return new Promise((resolve, reject) => {
                me.$http.get(me.$server_url + 'Todo_Libros_Series_Nombre_y_Codigo')
                    .then(res => {
                        if (Array.isArray(res.data)) {
                            // Mapear los datos agregando el campo nombreCompleto
                            const const_NombreLibro = res.data.map(item => ({
                                ...item,
                                nombreCompleto: `${item.nombre} - ${item.codigo_liquidacion}`
                            }));
                            // Incluye libros normales (ifcombo: 0) y combos (ifcombo: 1)
                            me.productos_Libros_Series = const_NombreLibro;
                            resolve();
                        } else {
                            throw new Error("La respuesta no es un arreglo válido.");
                        }
                    })
                    .catch(error => {
                        console.error("Error al traer libros de series:", error);
                        me.$vs.notify({
                            title: 'Error',
                            text: 'No se pudieron cargar las series de libros',
                            color: 'danger',
                            position: 'top-right'
                        });
                        reject(error);
                    });
            });
        },
        filtrarLibrosPorCodigos(libros) {
            if (!this.codigos_combo_buscar.length) {
                return libros; // Sin filtro, mostrar todos
            }

            return libros.filter(libro => {
                // Buscar por combo directo (ifcombo: 1)
                const esComboDirecto = this.codigos_combo_buscar.some(codigoSeleccionado => {
                    // Buscar en productos_Libros_Series si el código seleccionado es un combo
                    const productoSeleccionado = this.productos_Libros_Series.find(p => p.codigo_liquidacion === codigoSeleccionado);
                    return productoSeleccionado && productoSeleccionado.ifcombo === 1 && libro.pro_codigo === codigoSeleccionado;
                });

                if (esComboDirecto) {
                    return true;
                }

                // Buscar por códigos individuales en pro_codigos_desglose (libros normales)
                if (libro.pro_codigos_desglose && libro.pro_codigos_desglose.length > 0) {
                    const codigosDelLibro = libro.pro_codigos_desglose.map(c => c.codigo_liquidacion);
                    // Todos los códigos seleccionados deben estar en este libro
                    return this.codigos_combo_buscar.every(codigoSeleccionado => {
                        const productoSeleccionado = this.productos_Libros_Series.find(p => p.codigo_liquidacion === codigoSeleccionado);
                        // Solo aplicar filtro de códigos individuales si no es un combo
                        if (productoSeleccionado && productoSeleccionado.ifcombo === 0) {
                            return codigosDelLibro.includes(codigoSeleccionado);
                        }
                        return false;
                    });
                }

                return false;
            });
        },

        filtrarAreasPorCodigos(areas) {
            if (!this.codigos_combo_buscar.length) {
                return areas; // Sin filtro, mostrar todas las áreas
            }

            // Mostrar sólo áreas que tengan al menos un libro que cumple el filtro
            return areas.filter(area => {
                const librosFiltrados = this.filtrarLibrosPorCodigos(area.libros);
                return librosFiltrados.length > 0;
            });
        },
    },
}
</script>

<style scoped>
table.table_pedidos tr:hover {
    background-color: #E6E6E6;
    border: 2px solid #7C7C7C;
    color: black !important;
}

table.table_pedidos th {
    border: 1px solid rgb(227, 227, 227);
    height: 25px;
}

table.table_pedidos {
    width: 100%;
    border-collapse: collapse;
}

.input_totales {
    background-color: #E6E6E6;
    color: #000000 !important;
    font-weight: bold;
}

.input_pvp {
    background-color: #046AE7;
    color: #fff !important;
    border-radius: 0%;
    width: 100%;
    height: 100%;
}

.test {
    color: white !important;
    background-color: #6B97F5;
}

.test:hover,
.guiaEstilo:hover {
    color: black;
}

.guiaEstilo {
    /* color:white!important;
              background-color: #E2B832; */
}

.test2 {
    background-color: #C4D333;
}

.con-vs-tooltip>.vs-con-input-label>.vs-con-input>.vs-inputx {
    text-align: center !important;
    content: justify !important;
}

.cantidad-positiva {
  background-color: #e6f4ea !important;  /* verde claro elegante */
  border: 1px solid #046AE7 !important;  /* borde verde elegante */
  box-shadow: 0px 0px 4px 1px #08356b; /* sombra sutil para resaltar */
  border-radius: 6px;
  transition: 0.3s ease-in-out;
}
</style>
